import { motion } from "framer-motion";
import { equipmentGroups } from "../data";

export const Equipment = () => {
  return (
    <section
      id="equipment"
      data-testid="equipment"
      className="bg-[#0A0A0A] text-[#FAFAFA]"
    >
      <div className="px-6 sm:px-10 py-24 sm:py-32 mx-auto max-w-[1600px]">
        <div className="flex items-end justify-between mb-16 border-b border-neutral-800 pb-6">
          <h2 className="font-display font-medium tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none">
            Equipment list
          </h2>
          <span className="font-body text-xs tracking-[0.2em] uppercase text-neutral-500 hidden sm:block">
            Included
          </span>
        </div>

        <div className="space-y-16">
          {equipmentGroups.map((group, gi) => (
            <motion.div
              key={group.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`equipment-group-${gi}`}
              className="grid grid-cols-1 lg:grid-cols-12 gap-6"
            >
              <div className="lg:col-span-4">
                <h3 className="font-body text-xs tracking-[0.25em] uppercase text-neutral-500">
                  {String(gi + 1).padStart(2, "0")}
                </h3>
                <p className="font-display font-medium text-2xl sm:text-3xl tracking-tight mt-2">
                  {group.title}
                </p>
              </div>

              <ul className="lg:col-span-8 border-t border-neutral-800">
                {group.items.map((item, ii) => (
                  <li
                    key={ii}
                    data-testid={`equipment-item-${gi}-${ii}`}
                    className="flex items-baseline gap-5 py-3.5 border-b border-neutral-800 font-body text-base sm:text-lg text-neutral-200"
                  >
                    <span className="text-neutral-600 text-xs tabular-nums w-6 shrink-0">
                      {String(ii + 1).padStart(2, "0")}
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
